import { loadStripe } from '@stripe/stripe-js';
import React, { useState } from 'react';
import { useStateValue } from '../../context/StateProvider';
import axios from 'axios';
import { FiArrowRight } from 'react-icons/fi';
import { v4 as uuidv4 } from 'uuid';




 

const stripeAPI =
  'pk_test_51ISuksGFCmXQitVZp9YzmB0j99mcAjvedBrHUcxJsFoZ204QN42BnOeBKcbDQ6kfp7p7AU5yM2rfW3P47rsTQW5S00P9lKkN1E';
const stripePromise = loadStripe(stripeAPI);

const CheckoutV2 = ({ formData }) => {
  const [{ cart, products }] = useStateValue();
  const [loadingState, setLoadingState] = useState(false);
  console.log({cart});

  const handleClick = async (event) => {
    // Get Stripe.js instance
    setLoadingState(true);
    const stripe = await stripePromise;

    const orderUID = uuidv4();

    const orderID = orderUID.split("").splice(0,5).join('');
    console.log({orderID});

    const response = await axios.post(
      '/create-checkout-session',
      {
        orderID,
        customerDetails: formData,
        cart,
        products
      }
    );
    // console.log("timestamp", uuidv1())
    // console.log("response data", response.data);

    const session = await response.data;
    
    // When the customer clicks on the button, redirect them to Checkout.
    const result = await stripe.redirectToCheckout({
      sessionId: session.id
    });
    if (result.error) {
      // If `redirectToCheckout` fails due to a browser or network
      // error, display the localized error message to your customer
      // using `result.error.message`.
    }
  };


  return (


    <button className={`button ${loadingState ? "is-loading is-warning" : ""} `} role="link" onClick={handleClick}>
      Proceeed to Payment &nbsp; <FiArrowRight />
    </button>
  );
};

export default CheckoutV2;
